import { useLiveQuery } from 'dexie-react-hooks'
import { Icon } from '../../components/Icon'
import { getMeta, metaKeys, setMeta } from '../../db/meta'
import { isIos, isStandalone } from '../../push/push'

/** iOS Safari only delivers push to installed PWAs: nudge users to Add to Home Screen. */
export function IosInstallHint({ compact = false }: { compact?: boolean }) {
  const dismissed = useLiveQuery(() => getMeta<boolean>(metaKeys.iosHintDismissed), [], true)
  if (!isIos() || isStandalone()) return null
  if (compact && dismissed) return null
  return (
    <div className="inline-hint" role="note">
      <Icon name="share" />
      <div>
        <strong>Add to Home Screen to get notifications</strong>
        Tap the Share button in Safari, then “Add to Home Screen”. Open BOSS Chat from the new icon.
      </div>
      {compact ? (
        <button type="button" className="icon-button" aria-label="Dismiss install hint" onClick={() => void setMeta(metaKeys.iosHintDismissed, true)}>
          <Icon name="x" />
        </button>
      ) : null}
    </div>
  )
}
